import PlatformSlider from "../PlatformSlider/PlatformSlider.js";

export default class PlatformInteractive {

    constructor(element) {
        this.element = element;
        this.cubeElement = element.querySelector('.c-platform-cube');
        this.sliderElement = element.querySelector('.c-platform-slider');
        this.scrollTrigger = element.querySelector('.c-platform-interactive__scroll-trigger');

        this.slider = new PlatformSlider(this.sliderElement);

        this.handleStage1 = this.handleStage1.bind(this);
        this.stage1Observer = new IntersectionObserver(this.handleStage1, { threshold: 0.66 });
        this.stage1Observer.observe(this.element);

        this.handleStage2 = this.handleStage2.bind(this);
        this.stage2Observer = new IntersectionObserver(this.handleStage2, {
            rootMargin: '-50% 0% -50% 0%',
            threshold: 0,
        });
        this.stage2Observer.observe(this.scrollTrigger);
    }

    handleStage1(entries, observer) {
        if (!entries[0].isIntersecting) {
            return;
        }

        observer.unobserve(entries[0].target);
        this.cubeElement.classList.add('c-platform-cube--exploded');
    }

    handleStage2(entries, observer) {
        if (!entries[0].isIntersecting) {
            return;
        }

        observer.unobserve(entries[0].target);

        const animationOptions = {
            duration: 500,
            fill: 'both',
            easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
        }

        this.cubeElement.classList.remove('c-platform-cube--exploded');
        this.cubeElement.animate([
            { opacity: 1, transform: 'translate(-50%, -50%) scale(1)' },
            { opacity: 0, transform: 'translate(-50%, -50%) scale(0.75)' },
        ], animationOptions);

        this.sliderElement.style.visibility = 'visible';
        this.sliderElement.classList.add('c-platform-slider--visible');
        this.sliderElement.animate([
            { opacity: 0, transform: 'translate(-50%, -50%) scale(0.9)' },
            { opacity: 1, transform: 'translate(-50%, -50%) scale(1)' },
        ], animationOptions);
    }

}
